import { AnyAction } from 'redux';
import createSagaMiddleware from 'redux-saga';
import {
  GlobalEventDispatcher,
  GlobalPut,
  integrateReduxDevtoolsExtension,
  NgRefreshStore,
  PS20Store,
} from '@ps20-frontend/shop-integration-redux';
import { App, Produkt } from '@ps20-frontend/frontend-models';
import {
  gesamtbeitragMitRabattReducer,
  gesamtbeitragReducerForApp,
  jahresbeitragReducer,
  produktReducer,
} from '@ps20-frontend/reducers';
import combineSectionReducers from 'combine-section-reducers';

import cloneDeep from 'lodash/cloneDeep';
import { configureStore, Dispatch, Middleware, Tuple, UnknownAction } from '@reduxjs/toolkit';
import { rootReducer } from './reducers/rootReducer.reducer';
import { INITIAL_STATE } from './initialState';

import { IAppState } from './appState';
import { transientStateReducer } from './reducers/transient-state.reducer';
import { antragsnummerReducer } from './reducers/antragsnummer.reducer';
import { versicherungsnehmerReducer } from './reducers/versicherungsnehmer.reducer';
import { gegeVertragsoptionenReducer } from './reducers/vertragsoptionen.reducer';
import { gegenstandsschutzReducer } from './reducers/gegenstandsschutz.reducer';
import { gegeTaasInfoReducer } from './reducers/gegeTaasInfo.reducer';
import { rootSaga } from './sagas/rootSaga';
import { FahrradVorschaeden, fahrradVorschaedenReducer } from './reducers/fahrrad-vorschaeden.reducer';

export const reducers = combineSectionReducers({
  version: (version: number = null) => version,
  antragsnummer: antragsnummerReducer,
  transientState: transientStateReducer,
  versicherungsnehmer: versicherungsnehmerReducer,
  vertragsoptionen: gegeVertragsoptionenReducer,
  produkt: (sectionState: Produkt, action: AnyAction, state: IAppState) =>
    produktReducer(sectionState, action, App.GEGE, state?.angebotsId),
  taasInfo: gegeTaasInfoReducer,
  rabattstufe: (rabatstuffe: number = null) => rabatstuffe,
  gegenstandsschutz: gegenstandsschutzReducer,
  gesamtbeitragMitRabatt: gesamtbeitragMitRabattReducer,
  jahresbeitrag: jahresbeitragReducer,
  gesamtbeitrag: gesamtbeitragReducerForApp(App.GEGE),
  fahrradVorschaeden: (sectionState: FahrradVorschaeden, action: AnyAction, state: IAppState) =>
    fahrradVorschaedenReducer(sectionState, action, state?.angebotsId),
});

export function gegeStoreFactory(storeIndex: number): PS20Store<IAppState> {
  const ngRefreshStore = new NgRefreshStore<IAppState>(App.GEGE);
  const sagaMiddleware = createSagaMiddleware();
  const initialState = cloneDeep(INITIAL_STATE);
  const store = configureStore({
    reducer: rootReducer(reducers),
    devTools: integrateReduxDevtoolsExtension(`gege-angebot-gui-${storeIndex}`),
    preloadedState: initialState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(sagaMiddleware, ngRefreshStore.ngRefreshMiddleware) as unknown as Tuple<ReadonlyArray<Middleware<Record<string, never>, IAppState, Dispatch<UnknownAction>>>>,
  });

  sagaMiddleware.run(rootSaga);
  ngRefreshStore.setDelegate(store);
  return ngRefreshStore;
}

GlobalPut.getInstance().globalEventDispatcherFunction = () => {
  return (window as unknown as Record<string, unknown>)['globalEventDispatcher'] as GlobalEventDispatcher;
};
